import { orchestrator } from 'satcheljs';
import deleteContentWithSelector from 'owa-addins-editor-plugin/lib/utils/deleteContentWithSelector';
import updateContentToViewState from 'owa-editor/lib/utils/updateContentToViewState';
import { onAttachmentDeleted } from 'owa-calendar-compose-form-actions';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';

orchestrator(onAttachmentDeleted, actionMessage => {
    // when InlineAttachmnet is deleted, it gets deleted from attachmentWell but it remains in Compose mail body,
    // So it appears as broken image link. Below code will remove deleted inline attachmnet from body content.
    const composeViewState = getComposeViewState(actionMessage.formId);
    if (composeViewState && actionMessage.attachment.IsInline) {
        const cid = 'cid:' + actionMessage.attachment.ContentId;
        deleteContentWithSelector(composeViewState.bodyViewState, `img[originalsrc^="${cid}"]`);
        updateContentToViewState(composeViewState.bodyViewState);
    }
});
